import Message from 'rc-message';
import queryString from 'query-string';

// 上传图片格式检查
export const beforeUpload = (file: File, size: number = 5) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  // file.type === 'image/webp';
  if (!isJpgOrPng) {
    Message.error({
      content: window.trans('png-only'),
    });
  }
  const isLt2M = file.size / 1024 / 1024 < size;
  if (!isLt2M) {
    Message.error({
      content: window.trans('picture-tips'),
    });
  }
  return isJpgOrPng && isLt2M;
};
// 检查图片宽高是否复合要求
export const checkImgWAndH = (file: File, w: number = 400, h: number = 400) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = function (e: any) {
        const data = e.target.result;
        //加载图片获取图片真实宽度和高度
        const image = new Image();
        image.onload = function () {
          const width = image.width;
          const height = image.height;
          console.log(`width:${width}\nheight:${height}`);
          if (width !== w || height !== h) {
            resolve(false);
            Message.error({
              content: `${window.trans('size-only')}${w} * ${h}`,
            });
          } else {
            resolve(true);
          }
        };
        image.src = data;
      };
      reader.readAsDataURL(file);
    } catch (error) {
      resolve(false);
      Message.error({
        content: `加载异常，请重新上传!`,
      });
    }
  });
};
// 获取url的参数返回未一个对象，目前通过props注入全部路由
export const urlQuery = () => {
  const reg = /\?\S*/g;
  const queryParams = window.location.href.match(reg);
  const queryObj = queryParams ? queryString.parse(queryParams[0]) : {};
  return queryObj;
};
// 获取字符串的字节长度
export const getBytesLength = (str: string) => {
  var bytesCount = 0;
  for (var i = 0, n = str.length; i < n; i++) {
    var c = str.charCodeAt(i);
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      bytesCount += 1;
    } else {
      bytesCount += 2;
    }
  }
  return bytesCount;
};
// 转换时间
export function formatDate(dd: number | string) {
  const date: Date = new Date(dd);
  const y: number = date.getFullYear();
  let m: number | string = date.getMonth() + 1;
  let d: number | string = date.getDate();
  const h: number = date.getHours();
  const m1: number = date.getMinutes();
  // const s: number = date.getSeconds();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d + ' ' + h + ':' + m1;
}
// uuid
export function uuid() {
  const temp_url = URL.createObjectURL(new Blob());
  const uuid = temp_url.toString();
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf('/') + 1);
}
// 获取扩展名
export function getFileExtension(name: string) {
  const patternFileExtension = /\.([0-9a-z]+)(?:[\\?#]|$)/i;
  const fileExtension = name.match(patternFileExtension);
  return fileExtension ? fileExtension[0] : '';
}
